// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"styles_iconContainer__3nZVf","icon":"styles_icon__fwlHs","icon--black":"styles_icon--black__1K7QY","iconContainer--red":"styles_iconContainer--red__2as6w"};